// import components
import { styled, TableRow } from '@mui/material';

export const EmployeeRowStyles = styled(TableRow)(() => ({
  position: 'relative',
  pageBreakInside: 'avoid',
  breakInside: 'avoid',

  '& .cell-content': {
    height: '100%',
    overflow: 'hidden'
  },

  '& .croppedTextCell': {
    textOverflow: 'ellipsis',
    backgroundColor: 'inherit',

    '& span': {
      float: 'none',
      paddingRight: 0
    },

    '&:hover': {
      textOverflow: 'unset'
    },

    '& .chevron-icon': {
      fontSize: 10,
      margin: '0 4px',
      verticalAlign: 'middle',
      width: '12px',
      height: '12px'
    }
  }
}));
